import { Card } from "~/components/v4/shadcn/Card";
import CalendarCheckIcon from "../icons/CalendarCheckIcon";
import Link from "next/link";
import SharedHomeHeader from "./SharedHomeHeader";
import { CreateEventButton } from "../CreateEventModal";
import {
    GetCommunitiesToHost,
    GetCurrentUserProfile,
} from "~/app/beta/events/create/actions";
import HomeCreateCommunity from "../HomeCreateCommunity";
import CommunitiesTabIcon from "../icons/CommunitiesTabIcon";

type Props = {};

const CommunitiesHeader = ({}: Props) => {
    const title = "Join, host, or launch community events";
    const smallTitle = title;
    const subTitle = (
        <>
            Join events to meet people. Host to reach locals. Start a community
            to gather your people.
        </>
    );
    const smallSubTitle = "Start a community to gather your people.";
    const actionsBar = (
        <>
            {/* <HomeCreateCommunity
                size="sm"
                title="Launch community"
                variant="default"
            /> */}
            <Link
                href="https://app.getriver.io/discovery/communities"
                target="_blank"
                className="text-sm hover:underline"
            >
                Discover communities
            </Link>
        </>
    );
    const mobileActionsBar = (
        <div className="flex w-full flex-col gap-2">
            {/* <HomeCreateCommunity
                size="sm"
                title="Launch community"
                variant="default"
                className="w-full"
            /> */}
            <div className="flex w-full justify-between">
                <Link
                    href="https://app.getriver.io/discovery/communities"
                    target="_blank"
                    className="text-sm hover:underline"
                >
                    Discover communities
                </Link>
            </div>
        </div>
    );
    const squareIcon = <CommunitiesTabIcon className="h-[72px] w-[72px]" />;

    return (
        <SharedHomeHeader
            title={title}
            smallTitle={smallTitle}
            subTitle={subTitle}
            smallSubTitle={smallSubTitle}
            actionsBar={actionsBar}
            mobileActionsBar={mobileActionsBar}
            squareColor="#c9e9e8"
            squareIcon={squareIcon}
        />
    );
};

export default CommunitiesHeader;
